import axios from 'axios'
import { RrService, userStore } from '@/store'
import { GeneralError } from '@/store/entities'
import { ErrorUtils } from '@/commons/utils/error'
import { ENVIRONMENT } from '@/commons/configuration'

export class UserService {
    static async fetchUserRRInfo (): Promise<void> {
        if (userStore.isValidRrInfo) {
            return
        }

        userStore.rrRequestCancelToken = axios.CancelToken.source()
        if (!userStore.personCode) {
            throw new GeneralError(['errors.system.rrInfo.invalid'])
        }

        try {
            const response = await RrService.fetchRRInfo(ENVIRONMENT.rrUserUrl, userStore.rrRequestCancelToken)
            userStore.rrInfo = response.data
            userStore.rrRequestCancelToken = null
        } catch (e) {
            ErrorUtils.requestErrorHandler(ErrorUtils.resolveRequestErrorEntity(e))
        }
    }

    static cancelUserRrRequest (): void {
        if (userStore.rrRequestCancelToken) {
            userStore.rrRequestCancelToken.cancel()
        }
    }
}
